"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryChartView = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var c = (0, BemBuilder_1.default)("history-chart-view");
function HistoryChartView(_a) {
    var title = _a.title, data = _a.data, granularity = _a.granularity, selectedTimePeriod = _a.selectedTimePeriod, selectedCurrency = _a.selectedCurrency, FilterComponent = _a.FilterComponent, ChartComponent = _a.ChartComponent, firePipelineTelemetry = _a.firePipelineTelemetry;
    var _b = __read((0, react_1.useState)(null), 2), filters = _b[0], setFilters = _b[1];
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: c("heading-row") },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, title),
            react_1.default.createElement(FilterComponent, { onSelect: setFilters, firePipelineTelemetry: firePipelineTelemetry })),
        react_1.default.createElement("div", { className: c("chart-container") },
            react_1.default.createElement(ChartComponent, { filters: filters, data: data, granularity: granularity, selectedCurrency: selectedCurrency, selectedTimePeriod: selectedTimePeriod }))));
}
exports.HistoryChartView = HistoryChartView;
